import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

import "./AddEditPayment.js";
import "./PaymentList.js";

/**
    * class HSN.Widget.PaymentManagement
    *
    * Encapsulates the common functionality of the PaymentManagement Widget.
    **/
HSN.Widget.PaymentManagement = function () {
    var application;
    var container;
    var paymentService;
    var deviceInformation;
    var eventIdentity;
    var showSelectButton;
    var showDefaultCardChecked;
    var showMakeDefault;
    var hideSaveCard;
    var showAddPaypal;
    /**
        * new HSN.Widget.PaymentManagement.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.PaymentManagement]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        paymentService = application._getPaymentService();
        deviceInformation = application.DeviceInformation;
        showSelectButton = config.showSelectButton;
        showDefaultCardChecked = config.showDefaultCardChecked;
        showMakeDefault = config.showMakeDefault;
        hideSaveCard = config.hideSaveCard || false;
        showAddPaypal = config.showAddPaypal;
        eventIdentity = config.eventIdentity;
        ClearChildEventHandlers();
        bindEvents();
    }

    function bindEvents() {
        application.Events.On(HSN.Widget.PaymentList.EVENT.ADD_SELECTED, function () {
            SetContainerWait();
            paymentService.GetAddPaymentForm({ hideSaveCard: hideSaveCard }, {
                callback: function (data) {
                    SetPaymentContainerContent(data, false);
                    if (deviceInformation.IsMobile) {
                        ScrollToTop();
                    }
                },
                errorCallback: function () {
                    alert('Unfortunately there was an error attempting to add your payment method, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, function (paymentIdentity) {
            SetContainerWait();
            paymentService.GetEditPaymentForm(paymentIdentity, {}, {
                callback: function (data) {
                    SetPaymentContainerContent(data, true);
                    if(deviceInformation.IsMobile) {
                        ScrollToTop();
                    }
                },
                errorCallback: function () {
                    alert('Unfortunately there was an error attempting to edit your payment method, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, function (identity, isNoMoreCards) {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.REMOVE_SUCCESS, identity, isNoMoreCards);
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.SELECTED, function (paymentIdentity, eventIdentity) {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.SELECTED, paymentIdentity, eventIdentity);
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.DEFAULT_CHANGED, function() {
            application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.DEFAULT_CHANGED);
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.CANCELED, function (isEdit) {
            SetContainerWait();
            paymentService.GetPaymentList({ showSelect: showSelectButton, showDefaultCardChecked: showDefaultCardChecked, showMakeDefault: showMakeDefault, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
                callback: function (data) {
                    SetPaymentContainerContent(data, isEdit);
                },
                errorCallback: function () {
                    alert('Unfortunately there was an error attempting get the content, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, function (respData) {
            SetContainerWait();
            paymentService.GetPaymentList({ showSelect: showSelectButton, showDefaultCardChecked: showDefaultCardChecked, showMakeDefault: showMakeDefault, showAddPaypal: showAddPaypal, eventIdentity: eventIdentity }, {
                callback: function (data) {
                    SetPaymentContainerContent(data);
                    if (respData.isAdd) {
                        application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.ADD_NEW_PAYMENT_COMPLETE, respData);
                    }
                    else if (respData.isMakeDefault) {
                        application.Events.Trigger(HSN.Widget.PaymentManagement.EVENT.DEFAULT_CHANGED);
                    }
                },
                errorCallback: function () {
                    alert('Unfortunately there was an error attempting get the content, please try again.');
                }
            });
        });

        application.Events.On(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, function () {
                
        });

        application.Events.On(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED, function () {
                
        });
    }
    function SetContainerWait() {
        $('.payment-management-widget-container').html('');
        HSN.SetContainerWait('.payment-management-widget-container');
    }
    function SetPaymentContainerContent(content) {
        $('.payment-management-widget-container').html(content).find('[tabindex=0]').first().focus();
        HSN.RemoveContainerWait();
    }
    function ScrollToTop() {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    }
    function ClearChildEventHandlers() {
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.CANCELED, null, this);
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.SAVE_COMPLETE, null, this);
        application.Events.Off(HSN.Widget.AddEditPayment.EVENT.SAVE_FAILED, null, this);

        application.Events.Off(HSN.Widget.PaymentList.EVENT.ADD_SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.EDIT_SELECTED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.LIST_REFRESHED, null, this);
        application.Events.Off(HSN.Widget.PaymentList.EVENT.REMOVE_SUCCESS, null, this);

    }
    function Destroy() {
        application = container = paymentService = deviceInformation = null;
    }
    return {
        init: init,
        Destroy: Destroy
    }
};

HSN.Widget.PaymentManagement.EVENT = {
    CANCELLED: 'HSN.Widget.PaymentManagement:CANCELLED',
    SELECTED: 'HSN.Widget.PaymentManagement:SELECTED',
    DEFAULT_CHANGED: 'HSN.Widget.PaymentManagement:DEFAULT_CHANGED',
    ADD_NEW_PAYMENT_COMPLETE: 'HSN.Widget.PaymentManagement:ADD_NEW_PAYMENT_COMPLETE',
    REMOVE_SUCCESS: 'HSN.Widget.PaymentManagement:REMOVE_SUCCESS'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/PaymentManagement.js